import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router";
import { logger } from "@platform/browser-logger";
import { Button, Typography } from "@platform/design-system";
import { LogoWhite } from "@platform/portal-ui";

import useAuth from "../../hooks/useAuth";
import { isValidEmail } from "../../utils";
import { LoginPage, LOGIN_PAGE_TEST_ID } from "../../components/loginPage";
import PasswordSent from "../../components/passwordSent";

const errorMap = {
  "no-token": {
    heading: "Token is needed",
    message: "",
  },
  expired: {
    heading: "Expired Registration Link",
    message:
      "This registration link has expired. Please request a new invitation link from your Centro Administrator and register within 48 hours.",
  },
  cancelled: {
    heading: "Invalid Registration Link",
    message:
      "This registration link no longer exists. Please reach out to your team’s Centro Administrator with any questions.",
  },
  exist: {
    heading: "Account Already Created",
    message: "An account already exists. Click the button below to sign in.",
  },
  "password-update": {
    heading: "Password Update Required",
    message:
      "Due to recent system updates, all users will need to change their current passwords.",
    subMessage:
      "Click the button below to receive an email with a link to update your password.",
  },
};

const OnboardingError = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const caseId = searchParams.get("caseId") || "no-token";
  const { resetPassword } = useAuth();
  const navigate = useNavigate();
  const mfaState = JSON.parse(localStorage.getItem("mfaState"));
  const userName = mfaState && mfaState.username;
  const [passwordSent, setPasswordSent] = useState(false);
  const isValidInfo = !!userName && isValidEmail(userName);

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await resetPassword(userName);
      setPasswordSent(true);
    } catch ({ response }) {
      logger.error("Error in reset password", response);
      setLoading(false);
    }
  };
  return (
    <LoginPage
      container
      data-testid={LOGIN_PAGE_TEST_ID}
      justifyContent="space-between"
    >
      {!passwordSent ? (
        <Grid
          size={3}
          margin={"auto 6rem"}
          display={"flex"}
          flexDirection={"column"}
          gap={"32px"}
        >
          <>
            <Typography variant="display-medium">
              {errorMap[caseId].heading}
            </Typography>

            <Typography variant="body-medium">
              {errorMap[caseId].message}
            </Typography>

            {errorMap[caseId].subMessage && (
              <Typography variant="body-medium">
                {errorMap[caseId].subMessage}
              </Typography>
            )}

            {caseId == "exist" && (
              <Button
                fullWidth
                variant="primary"
                type="submit"
                onClick={() => navigate(`/`)}
                sx={{ py: 1, mt: 1 }}
              >
                Sign in
              </Button>
            )}

            {caseId == "password-update" && (
              <Button
                fullWidth
                variant="primary"
                type="submit"
                disabled={!isValidInfo || loading}
                loading={loading}
                onClick={handleUpdatePassword}
                sx={{ py: 1, mt: 1 }}
              >
                Update Password
              </Button>
            )}
          </>
        </Grid>
      ) : (
        <PasswordSent heading="Password Update Required" email={userName} />
      )}
      <Grid size={5} display="flex" alignItems="center" className="login-logo">
        <Box component="img" src={LogoWhite} alt="centro thumb" />
      </Grid>
    </LoginPage>
  );
};

export default OnboardingError;
